/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React, { useEffect, useState } from 'react'
import { Col, Card, CardBody, Button, Media, Row, Modal, ModalHeader, ModalBody } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useFetch } from '../../../../hooks/basic/useFetch'
import * as Icon from 'react-feather'
import styles from './NotificationList.module.scss'
import PaginationComponent from 'react-reactstrap-pagination'
import moment from 'moment'
import { AuthContext } from '../../../../auth/Auth'
import { useContext } from 'react'
import { notificationFetchListType, notificationFetchRowUpdateType } from '../types'
import { toast } from 'react-toastify'
import ReactDiffViewer from 'react-diff-viewer'
import getDifference from '../getDifference'
var classNames = require('classnames')

type propType = {
  searchFields?: Partial<{
    vendor_plan_meta: {
      vendor_ids: number[] | undefined
      category_id: number | undefined
      operator_id: number | undefined
      amount: number | undefined
    }
    circle_id: number | null
    type: string | undefined
    orderBy: 'id' | 'amount' | '' | undefined
    has_read?: 'true' | 'false' | '' | undefined
    real_time_plan_exist?: 'true' | 'false' | '' | undefined
    batch_id: number | undefined
    orderDirection: string | undefined
    perPage: number
  }>
  toggleForm?: boolean
  shouldAbortFetch: boolean
  shouldApplyCss: boolean
  xHit?: number
  shouldShowPagination?: boolean
}

export type stateType = {
  isLoading: boolean
  toggleButton: boolean
  xHit: number
  paginationOptions: {
    page: number
    perPage: number
    orderBy: string
    orderDirection: string
  }
}

const NotificationList: React.FC<propType> = (props) => {
  const [currentModalNotificationRecordID, setCurrentModalNotificationRecordID] = useState<null | number>(null)
  const [state, setState] = useState<stateType>({
    toggleButton: false,
    isLoading: false,
    xHit: 0,
    paginationOptions: {
      page: 1,
      perPage: 10,
      orderBy: 'updated_at',
      orderDirection: 'asc',
    },
  })

  const fetchedData = useFetch<notificationFetchListType['request'], notificationFetchListType['response']>(
    '/vendorNotification/list',
    {
      ...state.paginationOptions,
      ...(props.searchFields || {}),
    },
    true,
    () => props.shouldAbortFetch,
    state.xHit + (props.xHit || 0) // we don't have xHit here so we took from state and we took as props to use in notification
  )

  const list = fetchedData?.response?.data?.data || []

  const context = useContext(AuthContext)

  const fn = {
    updateRead: (id: number, hasRead: boolean) => async (e: any) => {
      try {
        const { json } = await context.http<
          notificationFetchRowUpdateType['request'],
          notificationFetchRowUpdateType['response']
        >('/vendorNotification/updateRead', { id: id, hasRead: hasRead })
        if (json.code !== 200) throw json.internalCode

        setState((prev) => ({ ...prev, xHit: prev.xHit + 1 }))

        hasRead ? toast.success('Changed to Read') : toast.warn('Changed to Unread')
      } catch (e) {
        if (typeof e !== 'string') e = 'Network error'
      }

      setState({ ...state, isLoading: false })
    },

    toggleButton: (e: any) => {
      e.preventDefault()
      setState((prev) => ({ ...prev, toggleButton: !prev.toggleButton }))
    },
  }
  useEffect(() => {
    if (fetchedData.status === 'success' && fetchedData.xHit > 0) {
      context.checkAuthStateless()
    }
  }, [state.xHit, fetchedData.status])
  return (
    <>
      <Row>
        <Col xs="12">
          <Card>
            {list.map((item, index) => {
              const getCurrentHelper = (item: any) => {
                if (item.type === 'new_plan') {
                  return {
                    nameText: 'New Plan',
                    containerClass: classNames('d-flex', styles['justify-content-between'], styles.background_green),
                    headingClass: classNames('success', styles['media-heading']),
                    icon: <Icon.CheckCircle className={classNames(styles['font-medium-5'], 'success')} size={21} />,
                  }
                } else if (item.type === 'remove_plan') {
                  return {
                    nameText: 'Remove Plan',
                    containerClass: classNames('d-flex', styles['justify-content-between'], styles.background_red),
                    headingClass: classNames('danger', styles['media-heading']),
                    icon: <Icon.AlertTriangle className={classNames(styles['font-medium-5'], 'danger')} size={21} />,
                  }
                } else {
                  return {
                    nameText: 'Change Plan',
                    containerClass: classNames('d-flex', styles['justify-content-between'], styles.background_yellow),
                    headingClass: classNames('warning', styles['media-heading']),
                    icon: <Icon.File className={classNames(styles['font-medium-5'], 'warning')} size={21} />,
                  }
                }
              }
              const current = getCurrentHelper(item)

              return (
                <div key={index}>
                  <div className={current.containerClass}>
                    <Media
                      className={
                        props.shouldApplyCss == true
                          ? styles.firang1
                          : classNames(styles['d-flex'], styles['align-items-start'], styles.firang)
                      }
                    >
                      <Media left href="#" className={styles.posIcon}>
                        {current.icon}
                      </Media>

                      <Media body className={styles.mediaBody}>
                        <Media heading className={current.headingClass} tag="h6">
                          {current.nameText}
                          <span
                            className={styles['notification-text']}
                            style={{ marginLeft: '48px', color: '#626262' }}
                          >
                            <b style={{ color: '#213b3b' }}>{item.vendor_plan_meta.operator_meta.name}</b>
                            <b>(Rs {item.vendor_plan_meta.amount})</b>
                          </span>
                          <span className={styles['notification-text']}>
                            <b style={{ color: 'orange' }}> Batch Id : {item.batch_id}</b>
                          </span>

                          <span className={styles.id_text}>ID: {item.id}</span>
                        </Media>
                        <Media heading className={current.headingClass} tag="h6">
                          <span className={styles['notification-text']} style={{ color: '#626262' }}>
                            <b>
                              Vendor:{' '}
                              {`${item.vendor_plan_meta.vendor_meta.id}. ${item.vendor_plan_meta.vendor_meta.name}`}
                            </b>
                          </span>
                          <span className={styles['notification-text']} style={{ color: '#626262' }}>
                            <b>
                              Realtime Plan Exist :
                              {item.real_time_plan_exist === 1 ? (
                                <span style={{ color: 'green', marginLeft: '33px' }}>Yes</span>
                              ) : (
                                <span style={{ color: 'red', marginLeft: '33px' }}>No</span>
                              )}
                            </b>
                          </span>
                          <span className={styles['notification-text']} style={{ color: '#626262', maxWidth: '350px' }}>
                            <b>
                              Circles:{' '}
                              {item.vendor_plan_meta.vendor_plans_circle_links
                                .map((d) => `${d.circle_meta.id}. ${d.circle_meta.name}`)
                                .join(', ')}
                            </b>
                          </span>
                        </Media>
                        <Media heading className={current.headingClass} tag="h6">
                          <span
                            className={styles['notification-text']}
                            style={{ color: '#626262', wordBreak: 'break-word', paddingRight: '10px' }}
                          >
                            <b> Description : {JSON.stringify(item?.description)}</b>
                            {/* <b> Description : {item?.vendor_plan_meta.description}</b> */}
                          </span>
                        </Media>
                      </Media>
                      <div>
                        <small className={styles['media-meta']}>{moment(item.updated_at).fromNow()}</small>
                        <br />
                        <div className={styles.flexbutton}>
                          <Link
                            to={`/vendor-plan/list?id=${item.vendor_plan_meta.id}`}
                            target="_blank"
                            className={classNames(styles.btn_read, styles.yellow)}
                          >
                            Vendor Plan
                          </Link>
                          {item.type === 'new_plan' && item.real_time_plan_exist === 0 ? (
                            <React.Fragment>
                              <Link
                                to={`/editplan?id=${0}&operator_id=${
                                  item.vendor_plan_meta.operator_id
                                }&circle_id=${item.vendor_plan_meta.vendor_plans_circle_links.map(
                                  (pcl) => pcl.circle_id
                                )}&amount=${item.vendor_plan_meta.amount} &vendor_id=${
                                  item.vendor_plan_meta.vendor_id
                                } &vendor_id=${item.vendor_plan_meta.vendor_id}`}
                                target={'_blank'}
                                className={classNames(styles.btn_read, styles.yellow)}
                              >
                                Add{' '}
                                <Icon.Plus
                                  size={13}
                                  height={10}
                                  className={styles.icon_right12}
                                  style={{ color: '#5e50ee' }}
                                />
                              </Link>
                            </React.Fragment>
                          ) : item.type === 'change_plan' ? (
                            <React.Fragment>
                              <Link
                                to={`/plan-list?operator_id=${item.vendor_plan_meta.operator_id}&amount=${item.vendor_plan_meta.amount}`}
                                target="_blank"
                                className={classNames(styles.btn_read, styles.yellow)}
                              >
                                View <Icon.FastForward size={13} height={10} className={styles.icon_right12} />
                              </Link>
                              <Button
                                color="primary"
                                className={classNames(styles.btn_read, styles.yellow, styles.detail)}
                                onClick={() => {
                                  setCurrentModalNotificationRecordID(item.id)
                                }}
                              >
                                Detail
                              </Button>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <Link
                                to={`/plan-list?operator_id=${item.vendor_plan_meta.operator_id}&amount=${item.vendor_plan_meta.amount}`}
                                target="_blank"
                                className={classNames(styles.btn_read, styles.yellow)}
                              >
                                View <Icon.FastForward size={13} height={10} className={styles.icon_right12} />
                              </Link>
                              <Link
                                to={`/editplan?id=${0}&operator_id=${
                                  item.vendor_plan_meta.operator_id
                                }&circle_id=${item.vendor_plan_meta.vendor_plans_circle_links
                                  .map((pcl) => pcl.circle_id)
                                  .join(',')}&amount=${item.vendor_plan_meta.amount}&vendor_id=${
                                  item.vendor_plan_meta.vendor_id
                                }`}
                                target={'_blank'}
                                className={classNames(styles.btn_read, styles.yellow)}
                              >
                                Add{' '}
                                <Icon.Plus
                                  size={13}
                                  height={10}
                                  className={styles.icon_right12}
                                  style={{ color: '#5e50ee' }}
                                />
                              </Link>
                            </React.Fragment>
                          )}

                          {item.has_read ? (
                            <Button
                              size="sm"
                              color="danger"
                              className={classNames(styles.colorAdded, styles.btn_read, styles.btn_unread)}
                              onClick={fn.updateRead(item.id, false)}
                            >
                              <Icon.EyeOff size={13} height={10} className={styles.icon_right} /> Unread
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              color="success"
                              className={classNames(styles.btn_read, styles.colorAdded)}
                              onClick={fn.updateRead(item.id, true)}
                            >
                              <Icon.Eye size={13} height={10} className={styles.icon_right} />
                              Read
                            </Button>
                          )}
                        </div>
                      </div>
                    </Media>
                  </div>
                  <div className={styles.toggleEffect}>
                    <h3 style={{ fontSize: '15px' }}>Vendor Plan Details</h3>
                  </div>

                  <div className={styles.detail_punch}>
                    <p>
                      Description: {item.vendor_plan_meta.description} / {item.vendor_plan_meta.validity}
                    </p>
                  </div>
                </div>
              )
            })}
          </Card>
        </Col>
      </Row>

      {fetchedData.status === 'success' &&
        fetchedData?.response?.code === 200 &&
        fetchedData?.response?.data?.meta?.total !== 0 && // for disable the pagination if there is no data
        props.shouldShowPagination === true && ( //response . code ===200
          <CardBody className={classNames(styles['card-body_custom'], styles.newBody)}>
            <PaginationComponent
              totalItems={fetchedData?.response?.data?.meta?.total!}
              // Number of items displayed each page

              pageSize={fetchedData?.response?.data?.meta?.per_page!}
              // Function to receive the event when a page is selected
              onSelect={(pageNumber) => {
                console.log('pagination', pageNumber)
                setState((prev) => ({
                  ...prev,
                  paginationOptions: {
                    ...prev.paginationOptions,
                    page: pageNumber,
                  },
                }))
              }}
              maxPaginationNumbers={7}
              defaultActivePage={state.paginationOptions.page}
              // Changes the size of the component. Values: "sm" and "lg". Without the prop the size is normal.
              size={undefined}
            />
          </CardBody>
        )}
      <Modal isOpen={currentModalNotificationRecordID != null}>
        <ModalHeader
          toggle={() => {
            setCurrentModalNotificationRecordID(null)
          }}
          style={{ fontSize: '20px' }}
        >
          The Changed Data
        </ModalHeader>
        <ModalBody>
          {list
            .filter((row) => row.type === 'change_plan' && row.id === currentModalNotificationRecordID)
            .map((row, i) => {
              // const objToString = (obj: { [k: string]: string }) => {
              //   const keys = Object.keys(obj)
              //   return keys.reduce((acc, cur) => {
              //     return acc + '\n cur: ' + obj[cur]
              //   }, '')
              // }

              const { prev, newData } = getDifference(row)
              return (
                <React.Fragment key={i}>
                  <ReactDiffViewer oldValue={prev} newValue={newData} splitView={false} />
                </React.Fragment>
              )
            }) || []}
        </ModalBody>
      </Modal>
    </>
  )
}
export default NotificationList
